/**
 * PATH: apps/assets/src/pages/AlertsPage.tsx
 * PURPOSE: Asset alerts and notifications
 */
import { EmptyRegister } from './emptyRegister'

export default function AlertsPage() {
  return (
    <EmptyRegister
      title="Alerts"
      detail="No asset alerts are connected."
    />
  )
}
